import { SummaryBannerNameLimit } from 'modules/frequencyManagement/lib/constants';
import styled from 'styled-components';
import { colors } from 'ui/theme';

const UlNoMargin = styled.ul`
  margin: 0;
  padding: 0;
`;

const LiTextSecondary = styled.li`
  color: ${colors.textSecondary};
`;

export const MessageNamesList = ({ names }: { names: string[] }) => {
  if (names.length > SummaryBannerNameLimit) {
    const first9 = names.slice(0, 9);
    const numRest = names.length - 9;
    const more = `And ${numRest} more message types`;

    return (
      <UlNoMargin>
        {first9.map((name) => (
          <li key={name}>{name}</li>
        ))}
        <LiTextSecondary>{more}</LiTextSecondary>
      </UlNoMargin>
    );
  }

  return (
    <UlNoMargin>
      {names.map((name) => (
        <li key={name}>{name}</li>
      ))}
    </UlNoMargin>
  );
};
